import {
    GET_LIST_MONITORING_OPERATOR,
    GET_LIST_MONITORING_STATUS_SIASN,
    GET_LIST_PROGRESS_MONITORING_ALL,
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
    data: {
        results: []
    },
    monitoring: {
        results: []
    },
    progress: {
        results: []
    },
    isExportDisabled: false,
};

const monitoringReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_MONITORING_OPERATOR: {
            return {
                ...state,
                data: action.payload
            }
        }
        case GET_LIST_MONITORING_STATUS_SIASN: {
            return {
                ...state,
                monitoring: action.payload
            }
        }
        case GET_LIST_PROGRESS_MONITORING_ALL: {
            const data = action.payload.results
            const dataProcessing = data.filter((item) => item.status === 'processing')
            return {
                ...state,
                isExportDisabled: dataProcessing.length > 0 ? true : false,
                progress: action.payload
            }
        }
        default:
            return state;
    }
};
export default monitoringReducer;
